/** Veri modelindeki sabit listeler — Prisma enum'larıyla birebir aynı. */
export const PRODUCT_CATEGORY = ['URETIM', 'ALSAT', 'HAMMADDE', 'HIZMET'];
export const UNIT = ['M2', 'ADET', 'KUTU', 'KG', 'LT', 'MTUL'];
export const STOCK_CHANNEL = ['OFFICIAL', 'OFFREC'];
export const MOVE_REASON = ['FATURA', 'ALIS_FATURA', 'ELLE', 'SAYIM', 'FASON', 'IADE'];
export const CUSTOMER_TYPE = ['BAYI', 'MIMAR', 'PROJE', 'PERAKENDE', 'FASONCU'];
export const PURCHASE_STATUS = ['BEKLIYOR', 'BAGLANDI', 'KISMEN'];
export const INFORMAL_STATUS = ['ACIK', 'KISMEN', 'KAPANDI'];
export const RECEIVABLE_SOURCE = ['INFORMAL', 'MANUEL'];
export const RECEIVABLE_STATUS = ['ACIK', 'KAPANDI'];
export const QUOTE_STATUS = ['TASLAK', 'GONDERILDI', 'ONAYLANDI', 'KAYBEDILDI'];
export const FASON_STATUS = ['GONDERILDI', 'KABUL', 'BASLADI', 'BITTI', 'SEVK', 'IPTAL'];
export const ORDER_STATUS = ['TALEP', 'NUMUNE', 'ONAY', 'URETIM', 'SEVK', 'TAHSILAT', 'KAPANDI'];
export const ORDER_SOURCE = ['MAIL', 'TELEFON', 'YUZYUZE', 'TEKLIF'];
export const ALERT_TYPE = ['STOK_ESIK', 'FIYAT_ARTIS', 'TAHSILAT', 'TEKLIF_ONAY', 'FASON_BEKLEME'];
/** Arayüzde gösterilen Türkçe etiketler. */
export const UNIT_LABEL = {
    M2: 'm²', ADET: 'adet', KUTU: 'kutu', KG: 'kg', LT: 'lt', MTUL: 'mtül',
};
export const CHANNEL_LABEL = {
    OFFICIAL: 'Resmî',
    OFFREC: 'Faturasız',
};
export const MOVE_REASON_LABEL = {
    FATURA: 'Satış faturası',
    ALIS_FATURA: 'Alış faturası',
    ELLE: 'Elle hareket',
    SAYIM: 'Sayım düzeltmesi',
    FASON: 'Fason iş',
    IADE: 'İade',
};
export const ORDER_STATUS_LABEL = {
    TALEP: 'Talep', NUMUNE: 'Numune', ONAY: 'Onay',
    URETIM: 'Üretim', SEVK: 'Sevk', TAHSILAT: 'Tahsilat', KAPANDI: 'Kapandı',
};
export const FASON_STATUS_LABEL = {
    GONDERILDI: 'Gönderildi', KABUL: 'Kabul etti', BASLADI: 'Başladı',
    BITTI: 'Bitirdi', SEVK: 'Sevk edildi', IPTAL: 'İptal',
};
export const QUOTE_STATUS_LABEL = {
    TASLAK: 'Taslak', GONDERILDI: 'Gönderildi',
    // "Onaylandı" değil: aynı ekranda iskonto TAVANI onayı da var, ikisi
    // karışıyordu. Şartname 4.3 bu durumu "satışa döndü mü" diye tarif ediyor.
    ONAYLANDI: 'Satışa döndü', KAYBEDILDI: 'Kaybedildi',
};
